var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstrumentalNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E5EAFF;}\r\n\t.st1{fill:#646464;}\r\n\t.st2{fill:#BFCCFF;}\r\n\t.st3{fill:#80FFFF;}\r\n\t.st4{fill:#7DF894;}\r\n\t.st5{fill:#FDFF20;}\r\n\t.st6{fill:#FFC800;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#FF9100;}\r\n\t.st9{fill:#F03903;}\r\n\t.st10{fill:#C50700;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2857_",
    className: "st9",
    d: "M255.8,4.7c140.3,0,254,113.7,254,254c0,140.2-113.7,253.9-254,253.9 c-140.3,0-254-113.7-254-253.9C1.8,118.5,115.5,4.7,255.8,4.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M155.3,174.2h33.1v168.9h-33.1V174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.6,257.2l-47.1-83h39.8l26.1,48.8l5.8,17.1l5.6-17.1l27.3-48.8h36l-48.7,81.3l51.2,87.6H317L287.3,291 l-6.5-17.9l-6.3,17.9l-29.9,52.1h-35.9L260.6,257.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentalNine);
export default __webpack_public_path__ + "static/media/InstrumentalNine.38b294b4f66e733def8285deb4502c94.svg";
export { ForwardRef as ReactComponent };